<script setup>
  import { computed } from "vue";
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import Popup from "@/components/controls/Popup.vue";

  const props = defineProps({
    modelInfo: {
      type: Object,
      required: true
    }
  });

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const popUpPositionY = computed(() => isDesktop.value ? 'top' : 'bottom');


</script>
<template>
  <Popup
    :id="props.modelInfo.id"
    icon="info"
    class="jwx-source-selector__popup-button"
    :positionY="popUpPositionY"
  >
    <template #default>
      <div class="jwx-source-selector__info-popup">
        <p class="jwx-source-selector__info-name">{{ props.modelInfo.modelName }}</p>
        <p class="jwx-source-selector__info-run-name">{{ props.modelInfo.modelRunName }}</p>
        <p class="jwx-source-selector__info-run-date">{{ props.modelInfo.runDate }}</p>
      </div>            
    </template>
  </Popup>
</template>